import React, { useEffect, useState } from "react";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import { useNavigate } from "react-router-dom";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import AppSubSections from "../../utils/AppSubSections";
import ButtonInfo from "../common/button/ButtonInfo";
import AppIcons from "../../utils/AppIcons";
import Pilot from "../../model/Pilot";
import ImgUtil from "../../utils/ImgUtil";

interface IPilotsListElementProps {
  data: Pilot;
  canEdit: boolean;
}

function PilotsListElement({ data, canEdit }: IPilotsListElementProps) {
  // reference to the navigator
  const navigate = useNavigate();

  return (
    <div
      className="list-row"
      onClick={() => {
        navigate(
          SETTINGS.get_path({
            section: AppSections.PILOTS,
            id: data.id,
            subsection: AppSubSections.VIEW,
          })
        );
      }}
    >
      {data.icon && (
        <div
          className="list-row-icon"
          style={{
            backgroundImage: `url(${ImgUtil.display_icon(data.icon_path)})`,
          }}
        ></div>
      )}

      <div className="list-row-content">
        <div className="list-row-header">
          <div className="list-row-title">
            <h3>{data.name}</h3>
          </div>
          <div>
            {canEdit && (
              <Button
                label="Edit"
                purpose={ButtonAction.EDIT}
                type={ButtonType.ICON_TEXT}
                onClick={() =>
                  navigate(
                    SETTINGS.get_path({
                      section: AppSections.PILOTS,
                      id: data.id,
                      subsection: AppSubSections.EDIT,
                    })
                  )
                }
              />
            )}
          </div>
        </div>

        <div className="list-row-description">{data.description}</div>
        <div className="list-row-footer">
          <ButtonInfo>
            {AppIcons.SITE}
            <span>{data.sites?.length}</span> sites
          </ButtonInfo>
          <ButtonInfo>
            {AppIcons.USER}
            Created by: <span>{data.username}</span>
          </ButtonInfo>
        </div>
      </div>
    </div>
  );
}

export default PilotsListElement;
